<template>
    <v-toolbar flat>
        <v-spacer />
        <TicketMapNavButtons />
    </v-toolbar>
</template>
<script>
import TicketMapNavButtons from './Map/TicketMapNavButtons';
export default {
    components: {
        TicketMapNavButtons,
    },
    data: () => ({
        tableMapToggle: 'table',
    }),
};
</script>